import SupplierAutomationView from '@/supplier-automation/SupplierAutomationView.vue'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {PanelContent} from '@tritt/multipanel'

const {registerNavigationCommand} = useContaCommand()

export const SUPPLIER_AUTOMATION: PanelContent = {
    componentName: 'SupplierAutomation',
    component: SupplierAutomationView,
    meta: {requiresOrg: true}
}
registerRoute(SUPPLIER_AUTOMATION)
registerNavigationCommand({
    route: SUPPLIER_AUTOMATION,
    label: 'Leverandørautomatisering',
    icon: 'i-ph-robot'
})
registerNavigationEntry(NavGroup.ORGANIZATION, {
    target: SUPPLIER_AUTOMATION,
    key: 'supplier-automation',
    title: 'Leverandørautomatisering',
    icon: 'i-ph-robot',
    sortOrder: 5
})